module.exports = __webpack_public_path__ + "static/media/mobile-image-3.70be9e01.png";